module.exports = __webpack_public_path__ + "static/media/company.473aec12.svg";